/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendCopiedProjectFieldDto } from '../../models/backend-copied-project-field-dto';
import { BackendCopiedProjectFieldRequestDto } from '../../models/backend-copied-project-field-request-dto';

export interface ProjectsCopiedProjectUpdate$FormData$Params {
  id: number;
  body?: BackendCopiedProjectFieldRequestDto;
}

export function projectsCopiedProjectUpdate$FormData(
  http: HttpClient,
  rootUrl: string,
  params: ProjectsCopiedProjectUpdate$FormData$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<BackendCopiedProjectFieldDto>> {
  const rb = new RequestBuilder(rootUrl, projectsCopiedProjectUpdate$FormData.PATH, 'put');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'multipart/form-data');
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<BackendCopiedProjectFieldDto>;
    }),
  );
}

projectsCopiedProjectUpdate$FormData.PATH = '/api/projects/copied_project/{id}/';
